export default __webpack_public_path__ + "static/media/stop-lines.b38b7f26.svg";